<div class="px-4 pt-2 my-5 text-center ">
  <h1 style="color: var(--secondary-color)" class="display-4 fw-bolder">{{ namePage }} </h1>
  <div class="container d-flex">
    <nav aria-label="breadcrumb " class="mx-auto">
      <ol class="breadcrumb container">
        <li class="breadcrumb-item  "><a routerLink="/">Inicio</a></li>
        <li class="breadcrumb-item fw-bolder"><a routerLink="{{ linkPage }}">{{ namePage }} </a></li>
      </ol>
    </nav>
  </div>
</div>
